import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const VIPCancel = () => {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center space-y-8">
        <div className="flex justify-center">
          <XCircle className="w-24 h-24 text-yellow-500" />
        </div>

        <div className="space-y-4">
          <h1 className="text-5xl font-bold">Subscription Cancelled</h1>
          <p className="text-xl text-gray-300">
            No worries! Your subscription wasn't processed.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-lg p-8 space-y-4">
          <p className="text-gray-300">
            If you changed your mind or had any issues during checkout, you can try again anytime.
          </p>
          <p className="text-gray-300">
            Our VIP membership includes:
          </p>
          <ul className="text-left space-y-2 text-gray-300 max-w-md mx-auto">
            <li>• 2 back-catalogue tracks instantly</li>
            <li>• 2 more tracks every month (on the 1st)</li>
            <li>• Early access to all new releases</li>
            <li>• Exclusive VIP dubs</li>
            <li>• Only £4.99/month</li>
          </ul>
        </div>

        <div className="flex gap-4 justify-center">
          <Link
            to="/vip"
            className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
          >
            Try Again
          </Link>
          <Link
            to="/"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VIPCancel;
